import { Box, Skeleton, pn, Typography } from '@compass/core';
import { Column } from 'devextreme-react/data-grid';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { DevExpressReport } from 'components';
import { useGenderData } from '../contexts';
import { GenderFilterControls } from './GenderFilterControls';
import { DashboardCard } from '../components/DashboardCard';
import { GenderDistributionDto } from 'generated/openApi';

const GenderTable = (props: { rows: GenderDistributionDto[]; loading: boolean }) => {
    const appTenantName = useSelector((state: RootState) => state.app.tenantName);

    if (props.loading) {
        return <Skeleton variant="rounded" height={400} />;
    }

    return (
        <DevExpressReport
            dataSource={props.rows}
            fullPageSize
            showColumnChooser={false}
            exportFormats={['pdf', 'excel', 'csv']}
            onExporting={() => ({
                header: 'Gender',
                filename: 'Gender_Distribution',
                tenantName: appTenantName,
            })}
        >
            <Column
                dataField={pn<GenderDistributionDto>('year')}
                caption="School Year"
                alignment="left"
                cellRender={(data: { value: number }) => `${data.value}-${data.value + 1}`}
            />
            <Column
                dataField={pn<GenderDistributionDto>('genderName')}
                caption="Gender"
                alignment="left"
            />
            <Column
                dataField={pn<GenderDistributionDto>('studentCount')}
                caption="Count"
                alignment="left"
            />
            <Column
                dataField={pn<GenderDistributionDto>('percentage')}
                caption="Percentage"
                alignment="left"
                cellRender={(data: { value: number }) => `${data.value}%`}
            />
        </DevExpressReport>
    );
};

const GenderTableCardContent = () => {
    const { data, loading, error } = useGenderData();

    if (error) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <GenderFilterControls />
                <Typography color="error" align="center" sx={{ mt: 4 }}>
                    {error}
                </Typography>
            </Box>
        );
    }
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <GenderFilterControls />
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <GenderTable rows={data} loading={loading} />
            </Box>
        </Box>
    );
};

export const GenderTableCard = () => (
    <DashboardCard title="Gender">
        <GenderTableCardContent />
    </DashboardCard>
);